export default __webpack_public_path__ + "static/media/marvel-hawkeye.1f78e874.jpg";